<template>
  <div>
    <button
      qaid="build-a-bundle-cta"
      class="bg-gray-05 flex justify-between items-center p-2 my-2"
      @click="showAccessoryFinder"
    >
      <div>
        <div class="font-bold" v-html="bp('buildBundle')" />
        <p class="text-sm leading-normal" v-html="bp('electraAccessoryFinderAddTo', product.name)" />
      </div>
      <i class="material-icons">chevron_right</i>
    </button>
    <div>
      <el-dialog
        :visible.sync="dialogVisible"
        :center="true"
        :width="viewBreakpointMoreThan('medium') ? '70vw' : '90vw'"
        :close-on-press-escape="true"
        :close-on-click-modal="true"
        :z-index="16000011"
        :close-dialog-tooltip="bp('closeDialogToolTip')"
        @close="close"
      >
        <div id="accessory-finder-container" />
      </el-dialog>
    </div>
    <div v-show="false" id="accessory-finder-loading-container">
      <div id="zoovu-assistant" />
    </div>
  </div>
</template>

<script>
import ElDialog from '@/components/Dialog';
import viewSize from '@/mixins/view-size';
import zoovuAddToCart, {ZOOVU_LOADED} from '@/zoovu/mixins/addToCart';

export default {
  name: 'PdpBuildABundleCta',
  components: {ElDialog},
  mixins: [viewSize, zoovuAddToCart],
  props: {
    product: {
      type: Object,
      required: true,
    },
    variantCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  watch: {
    variantCode() {
      window.history.replaceState(null, null, `?vc=1475272&esp=${this.variantCode}`);
      // the accessory finder is not responsive to changes in the url params so it must be rebuilt every time a new bike variant is selected
      this.rebuildAccessoryFinder();
    },
  },
  created() {
    window.history.replaceState(null, null, `?vc=1475272&esp=${this.variantCode}`);
    let accessoryFinderScript = document.createElement('script');
    accessoryFinderScript.setAttribute(
      'src',
      'https://tiger-cdn.zoovu.com/advisor-fe-web/api/v1/advisors/Mrt59zjL/js-loader?locale=en-US'
    );
    accessoryFinderScript.setAttribute('id', 'accessory-finder-script');
    document.head.appendChild(accessoryFinderScript);

    this.$on(ZOOVU_LOADED, this.close);
  },
  methods: {
    showAccessoryFinder() {
      this.dialogVisible = true;
      let accessoryFinderNode = document.getElementById('zoovu-assistant');
      this.$nextTick(() => {
        document.getElementById('accessory-finder-container').appendChild(accessoryFinderNode);
      });
    },
    rebuildAccessoryFinder() {
      // it rebuilds in a hidden div because it is slow to compile and this dramatically reduces the amount of time a user will watch a loading spinner
      let accessoryFinderNode = document.getElementById('zoovu-assistant');
      accessoryFinderNode.parentElement.removeChild(accessoryFinderNode);
      let newAccessoryFinderNode = document.createElement('div');
      newAccessoryFinderNode.id = 'zoovu-assistant';
      document.getElementById('accessory-finder-loading-container').appendChild(newAccessoryFinderNode);
      this.rerunAccessoryFinderScript();
    },
    rerunAccessoryFinderScript() {
      let oldScript = document.getElementById('accessory-finder-script');
      oldScript.parentNode.removeChild(oldScript);
      let accessoryFinderScript = document.createElement('script');
      accessoryFinderScript.setAttribute(
        'src',
        'https://tiger-cdn.zoovu.com/advisor-fe-web/api/v1/advisors/Mrt59zjL/js-loader?locale=en-US'
      );
      accessoryFinderScript.setAttribute('id', 'accessory-finder-script');
      document.head.appendChild(accessoryFinderScript);
    },
    close() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
button:focus {
  outline: none;
  box-shadow: 0 0 0.125rem 0.0625rem var(--white), 0 0 0.125rem 0.125rem var(--blue-100);
}
</style>
